import { MatchViewerH2HTeams } from "./H2H/MatchViewerH2HTeams";
import { Match } from "model/Match/Match";
import { MatchViewerRowedTeams } from "./Rowed/MatchViewerRowedTeams";
import { Panel } from "components/Panel/Panel";
import { selectMatchSummaryFromMatchId } from "selectors/Match";
import { MatchViewerTabledTeams } from "./Tabled/MatchViewerTabledTeams";
import { getNumTeams } from "model/Match/MatchTeams";
import { useAppSelector } from "app/hooks";

interface Props {
  match: Match;
  tournamentId: string;
}

export const MatchViewerTeams = ({ match, tournamentId }: Props) => {
  const matchSummary = useAppSelector((state) =>
    selectMatchSummaryFromMatchId(state, match.id)
  );

  const numTeams = getNumTeams(match.teams);

  if (numTeams === 2) {
    return (
      <Panel header={matchSummary} padding="padded">
        <MatchViewerH2HTeams match={match} tournamentId={tournamentId} />{" "}
      </Panel>
    );
  }

  if (numTeams <= 12) {
    return (
      <Panel header={matchSummary} padding="padded">
        <MatchViewerRowedTeams match={match} tournamentId={tournamentId} />
      </Panel>
    );
  }

  return (
    <Panel header={matchSummary}>
      <MatchViewerTabledTeams match={match} tournamentId={tournamentId} />
    </Panel>
  );
};
